(() => {
  const day = 86400000;
  const parseDate = (value) => {
    if (typeof value !== 'string' || !/^\d{4}-\d{2}-\d{2}$/.test(value)) return NaN;
    const time = Date.parse(`${value}T00:00:00Z`);
    return Number.isFinite(time) && new Date(time).toISOString().slice(0, 10) === value ? time : NaN;
  };
  const parseCents = (value) => {
    if (!['number', 'string'].includes(typeof value) || !/^\d+(?:\.\d+)?$/.test(String(value))) return NaN;
    const cents = Number(value);
    return Number.isFinite(cents) && cents >= 0 && cents <= Number.MAX_SAFE_INTEGER ? cents : NaN;
  };
  const init = () => {
    document.querySelectorAll('[data-cinoton-product-promotion]').forEach((promotion) => {
      const chart = promotion.querySelector('[data-cinoton-history-chart]');
      const source = promotion.querySelector('[data-cinoton-price-history]');
      if (!chart || !source || chart.dataset.historyInitialized) return;
      chart.dataset.historyInitialized = 'true';
      let records = [];
      try { const parsed = JSON.parse(source.textContent); if (Array.isArray(parsed)) records = parsed.slice(0, 50); } catch (_) { /* Invalid input keeps the honest empty state. */ }
      const today = parseDate(chart.dataset.today);
      const days = Math.max(1, Math.min(365, Math.trunc(Number(chart.dataset.days)) || 30));
      const cutoff = today - (days - 1) * day;
      const currency = (window.Shopify?.currency?.active || chart.dataset.currency || '').toUpperCase();
      let money;
      try { money = new Intl.NumberFormat(document.documentElement.lang || 'en', {style: 'currency', currency}); }
      catch (_) { return; }
      const format = (cents) => money.format(cents / 100);
      const labelDate = (time) => new Date(time).toISOString().slice(0, 10);
      const line = chart.querySelector('[data-history-line]');
      const fill = chart.querySelector('[data-history-fill]');
      const range = promotion.querySelector('[data-history-range]');
      const details = promotion.querySelector('[data-history-records]');
      const list = promotion.querySelector('[data-history-list]');
      const summary = details.querySelector('summary');
      const originalSummary = summary.textContent;
      const description = promotion.querySelector('[data-history-description]');
      const originalDescription = description?.textContent || '';
      const offerLabel = promotion.querySelector('[data-cinoton-promotion-toggle] > span');
      const originalOffer = offerLabel?.textContent || '';
      const demoNote = promotion.querySelector('[data-history-demo-note]');
      const disclaimer = promotion.querySelector('[data-history-disclaimer]');
      const valid = records.filter((record) => record && Number.isFinite(parseDate(record.date)) && parseDate(record.date) <= today && Number.isFinite(parseCents(record.cents)));
      const draw = () => {
        // Never mix a variant-specific series with another variant or currency.
        const variantId = chart.dataset.variantId;
        const variantRecords = valid.filter((record) => String(record.variantId || '') === variantId);
        const scoped = variantRecords.length ? variantRecords : valid.filter((record) => !record.variantId);
        const points = new Map();
        scoped.forEach((record) => {
          const date = parseDate(record.date);
          if (date >= cutoff && record.currency === currency) points.set(date, parseCents(record.cents));
        });
        const current = parseCents(chart.dataset.currentPrice);
        chart.classList.toggle('is-unavailable', !Number.isFinite(current));
        const hasEarlier = [...points.keys()].some((date) => date < today);
        const ready = Number.isFinite(today) && Number.isFinite(current) && hasEarlier;
        const demo = !ready && Number.isFinite(current) && Number.isFinite(today) && chart.dataset.demoFallback === 'true';
        chart.dataset.historyMode = ready ? 'recorded' : demo ? 'example' : 'empty';
        chart.classList.toggle('has-history', ready || demo);
        chart.classList.toggle('is-example', demo);
        if (description) {
          description.textContent = demo ? 'Illustrative example — not recorded prices' : originalDescription;
          description.hidden = !description.textContent;
        }
        if (offerLabel) offerLabel.textContent = demo ? 'Price trend (example)' : originalOffer;
        if (demoNote) demoNote.hidden = !demo;
        if (disclaimer) disclaimer.hidden = demo;
        range.hidden = details.hidden = !ready && !demo;
        summary.textContent = demo ? 'View example prices' : originalSummary;
        list.replaceChildren();
        if (demo) {
          // Deterministic generated examples, not dates or recorded selling prices.
          points.clear();
          const offset = (Math.round(current) % 17) / 1000;
          [1.04 + offset, 0.97 - offset, 1.08 + offset, 1.02, 0.99, 1].forEach((factor, index) => {
            points.set(index, index === 5 ? current : Math.min(Number.MAX_SAFE_INTEGER, Math.round(current * factor)));
          });
        }
        if (!ready && !demo) {
          line.removeAttribute('d'); fill.removeAttribute('d');
          chart.setAttribute('aria-label', 'Price history unavailable for this selection');
          return;
        }
        // Today is live, not a recorded data point; its source is labelled in the list.
        if (!demo) points.set(today, current);
        const series = [...points.entries()].sort((a, b) => a[0] - b[0]);
        const prices = series.map((entry) => entry[1]);
        const low = Math.min(...prices); const high = Math.max(...prices);
        const first = series[0][0];
        const end = series[series.length - 1][0];
        const x = (time) => 18 + (time - first) * 276 / Math.max(1, end - first);
        const y = (price) => high === low ? 55 : 94 - (price - low) * 77 / (high - low);
        let path = `M18 ${y(series[0][1]).toFixed(2)}`;
        series.slice(1).forEach(([date, price]) => { path += `H${x(date).toFixed(2)}V${y(price).toFixed(2)}`; });
        line.setAttribute('d', path);
        fill.setAttribute('d', `${path}V102H18Z`);
        chart.querySelectorAll('[data-history-dot], [data-history-halo]').forEach((dot) => dot.setAttribute('cy', y(current).toFixed(2)));
        chart.querySelector('[data-history-start]').textContent = demo ? 'Example' : labelDate(first);
        range.textContent = `${demo ? 'Example range' : 'Range'}: ${format(low)} – ${format(high)}`;
        series.forEach(([date, price], index) => {
          const item = document.createElement('li');
          item.textContent = demo
            ? (index === series.length - 1 ? `Today: ${format(price)} (actual current price)` : `Example ${index + 1}: ${format(price)} (generated)`)
            : `${labelDate(date)}: ${format(price)}${date === today ? ' (current variant price)' : ' (recorded)'}`;
          list.append(item);
        });
        chart.setAttribute('aria-label', demo
          ? `Illustrative example generated from current price ${format(current)}, not actual price history. Example range ${format(low)} to ${format(high)}.`
          : `Entered price history from ${labelDate(first)} to today. Range ${format(low)} to ${format(high)}. Current selected variant ${format(current)}.`);
      };
      draw();
      document.addEventListener('product:variant-change', (event) => {
        if (event.detail?.sectionId && event.detail.sectionId !== promotion.dataset.section) return;
        const variant = event.detail?.variant;
        if (!variant) {
          chart.dataset.variantId = '';
          chart.dataset.currentPrice = '';
          const price = chart.querySelector('[data-cinoton-trend-price]');
          if (price) price.textContent = '';
          draw();
          return;
        }
        if (variant.id != null) chart.dataset.variantId = String(variant.id);
        chart.dataset.currentPrice = String(variant.price);
        draw();
      });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once: true});
  else init();
  document.addEventListener('shopify:section:load', init);
})();
